module.exports = __webpack_public_path__ + "static/img/icon-08.509abb95.png";